import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, inject, Injectable, Injector, isDevMode } from "@angular/core";
import { NiceToastService } from "@recursyve/nice-ui-kit.v2";
import * as Sentry from "@sentry/angular";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    private readonly injector = inject(Injector);

    private readonly sentry = Sentry.createErrorHandler({
        logErrors: true
    });

    public handleError(error: Error | HttpErrorResponse): void {
        const notificationService = this.injector.get(NiceToastService);

        let message = error.message;
        if (!isDevMode()) {
            message = "handler.prod_message";
        }

        notificationService.error(message);

        return this.sentry.handleError(error);
    }
}
